import { platformIntl } from '../../../constants';
import { MessageNavType } from '../interfaces';
import {
    MultiNavAppSettingsDefaultIcon,
    MultiNavAppSettingsSelectedIcon,
    MultiNavDataNotificationsDefaultIcon,
    MultiNavDataNotificationsSelectedIcon,
    MultiNavExternalMessagesDefaultIcon,
    MultiNavExternalMessagesSelectedIcon,
    MultiNavExternalOrganizationDefaultIcon,
    MultiNavExternalOrganizationSelectedIcon,
    MultiNavInternalOrganizationDefaultIcon,
    MultiNavInternalOrganizationSelectedIcon,
    MultiNavMessagePushDefaultIcon,
    MultiNavMessagePushSelectedIcon,
    MultiNavOrderDetailsDefaultIcon,
    MultiNavOrderDetailsSelectedIcon,
    MultiNavPlanDetailsDefaultIcon,
    MultiNavPlanDetailsSelectedIcon,
    MultiNavProjectNotificationDefaultIcon,
    MultiNavProjectNotificationSelectedIcon,
    MultiNavSpaceNotificationsDefaultIcon,
    MultiNavSpaceNotificationsSelectedIcon,
    MultiNavFdlJieguotongzhiDefaultIcon,
    MultiNavFdlJieguotongzhiSelectedIcon,
    MultiNavStatisticsDefaultIcon,
    MultiNavStatisticsSelectedIcon,
    MultiNavSystemManagementDefaultIcon,
    MultiNavSystemManagementSelectedIcon
} from '@fx-ui/icon';

/**
 * 获取菜单文案
 *
 * @param type 类型
 */
export const getMessageNavItemText = (type: MessageNavType): string => {
    switch (type) {
        case MessageNavType.External:
            return platformIntl.get('fxp.base.workspace.msg.extra_msg.ttl');
        case MessageNavType.MessageSetting:
            return platformIntl.get('message.setting');
        default:
            return '';
    }
};

/**
 * 根据消息导航项类型获取其对应的图标资源
 * @param type 消息中心侧边导航一级类型
 */
export const getMessageNavItemIcon = (type: MessageNavType) => {
    switch (type) {
        /**
         * 简道云导航栏icon
         */
        case MessageNavType.DataNotify:
            return {
                icon: MultiNavDataNotificationsDefaultIcon,
                activeIcon: MultiNavDataNotificationsSelectedIcon
            };
        case MessageNavType.AppLog:
            return {
                icon: MultiNavPlanDetailsDefaultIcon,
                activeIcon: MultiNavPlanDetailsSelectedIcon
            };
        case MessageNavType.KmsDoc:
            return {
                icon: MultiNavOrderDetailsDefaultIcon,
                activeIcon: MultiNavOrderDetailsSelectedIcon
            };
        /**
         * 九数云导航栏icon
         */
        case MessageNavType.AnalyticsProjectNotify:
            return {
                icon: MultiNavProjectNotificationDefaultIcon,
                activeIcon: MultiNavProjectNotificationSelectedIcon
            };
        case MessageNavType.AnalyticsSpaceNotify:
            return {
                icon: MultiNavSpaceNotificationsDefaultIcon,
                activeIcon: MultiNavSpaceNotificationsSelectedIcon
            };
        case MessageNavType.AnalyticsOtherNotify: {
            return {
                icon: MultiNavDataNotificationsDefaultIcon,
                activeIcon: MultiNavDataNotificationsSelectedIcon
            };
        }
        /**
         * 集成治理导航栏icon
         */
        case MessageNavType.GovernanceResultNotification: {
            return {
                icon: MultiNavFdlJieguotongzhiDefaultIcon,
                activeIcon: MultiNavFdlJieguotongzhiSelectedIcon
            };
        }
        /**
         * 企业消息导航栏icon
         */
        case MessageNavType.UsageNotify:
            return {
                icon: MultiNavStatisticsDefaultIcon,
                activeIcon: MultiNavStatisticsSelectedIcon
            };
        case MessageNavType.TenantCoop:
            return {
                icon: MultiNavInternalOrganizationDefaultIcon,
                activeIcon: MultiNavInternalOrganizationSelectedIcon
            };
        case MessageNavType.OpenPlatform:
            return {
                icon: MultiNavExternalOrganizationDefaultIcon,
                activeIcon: MultiNavExternalOrganizationSelectedIcon
            };
        case MessageNavType.SystemManagement:
            return {
                icon: MultiNavSystemManagementDefaultIcon,
                activeIcon: MultiNavSystemManagementSelectedIcon
            };
        case MessageNavType.OperationNotify:
            return {
                icon: MultiNavMessagePushDefaultIcon,
                activeIcon: MultiNavMessagePushSelectedIcon
            };
        case MessageNavType.External:
            return {
                icon: MultiNavExternalMessagesDefaultIcon,
                activeIcon: MultiNavExternalMessagesSelectedIcon
            };
        case MessageNavType.MessageSetting:
            return {
                icon: MultiNavAppSettingsDefaultIcon,
                activeIcon: MultiNavAppSettingsSelectedIcon
            };
        default:
            return {};
    }
};

// 获取默认的滚动条大小
let scrollbarSize: { width: number; height: number } = { width: 0, height: 0 };
export const getScrollbarSize = () => {
    // 如果之前计算过，则直接返回全局缓存的计算结果，避免重复计算
    if (scrollbarSize.width && scrollbarSize.height) {
        return scrollbarSize;
    }
    const scrollDiv = document.createElement('div');

    scrollDiv.style.position = 'absolute';
    scrollDiv.style.width = '100px';
    scrollDiv.style.height = '100px';
    scrollDiv.style.overflow = 'scroll';
    scrollDiv.style.top = '-9999px';

    document.body.appendChild(scrollDiv);
    const scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
    const scrollbarHeight = scrollDiv.offsetHeight - scrollDiv.clientHeight;
    document.body.removeChild(scrollDiv);
    scrollbarSize = { width: scrollbarWidth, height: scrollbarHeight };

    return scrollbarSize;
};
